import React from 'react';
import PropTypes from 'prop-types';
import '../assets/styles.css'

const Link = ({ children, onClick }) => {
    return (
        <div
            className={'_kanis_styled_link'}
            onClick={onClick}
        >
            {children}
        </div>
    );
}

export default Link;

Link.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
};